import styled from '@emotion/styled'
import ReactPopover from 'react-popover'
import { MODAL_Z_INDEX } from '../modal'

import { palette, spacing } from 'main/ui'

export const Container = styled.div`
  background-color: ${palette.white};
  border-radius: 10px;
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.25);
  padding: ${spacing.majorScale(2)}px;
`

export const Header = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: -${spacing.minorScale(3)}px;
`

export const CrossIconContainer = styled.div`
  color: ${palette.mediumGray};
  cursor: pointer;
  margin-left: auto;
  min-width: 14px;
  width: 14px;
`

export const StyledPopover = styled(ReactPopover)`
  z-index: ${MODAL_Z_INDEX + 1};
`
